// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"fc70dcc8","619":"8899237e","626":"086925c9","787":"68e3b868"}[chunkId] + ".chunk.js";
};